import { isEmpty } from 'lodash'

import i18n from '@/i18n/i18n'
import { KeysfinReportService } from '@/services/admin/KeysfinReportService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['title']

export const state = {
  all_keysfin_report_data: []
}

export const mutations = {
  SET_FINANCIAL_INFO(state, financialInfo) {
    state.all_keysfin_report_data[financialInfo.reportId] = financialInfo.data.data
  }
}

export const actions = {
  getKeysfinReportInfo({ commit, dispatch }, params) {
    const { applicationId, keysfinRequestId, keysfinReportService } = params
    if (!isEmpty(state.all_keysfin_report_data[keysfinRequestId])) {
      return state.all_keysfin_report_data[keysfinRequestId]
    }

    return new Promise((resolve, reject) => {
      let KeysfinReportServiceObject = new KeysfinReportService()

      KeysfinReportServiceObject.getApplicationsReadyKeysfinReports(applicationId, keysfinRequestId)
        .then(response => {
          commit('SET_FINANCIAL_INFO', { data: response, reportId: keysfinReportService })
          resolve(response.data)
        })
        .catch(err => {
          if (err.response.status == 404) {
            reject(err)
            return
          }
          const notification = {
            type: 'danger',
            message:
              t('views.admin.applications.keysfin_report.error_while_getting_keysfin_financial_info_report') +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCompletedKeysfinAMLReports({ commit, dispatch }, params) {
    const { applicationId, keysfinReportService } = params

    return new Promise((resolve, reject) => {
      let KeysfinReportServiceObject = new KeysfinReportService()

      KeysfinReportServiceObject.getApplicationsReadyKeysfinAMLReports(applicationId)
        .then(response => {
          commit('SET_FINANCIAL_INFO', { data: response, reportId: keysfinReportService })
          resolve(response.data)
        })
        .catch(err => {
          if (err.response.status === 404) {
            reject(err)
            return
          }
          const notification = {
            type: 'danger',
            message:
              t('views.admin.applications.keysfin_report.error_while_getting_keysfin_financial_info_report') +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
